import Chair from './chair';
import SpaceSuit from './space_suit';
import Navigator from './navigator';
import Shield from './shield';
import CargoScanner from './cargo_scanner';
import Hammer from './hammer';
import Table from './table';
import Cryopod from './cryopod';
import O2Tank from './o2tank';
import Potato from './potato';
import Server from './server';
import Han from './han';
import FireExtinguisher from './fire_extinguisher';
import Medbed from './medbed';
import VacuumCleaner from './vacuum_cleaner';
import GunTerminal from './gun_terminal';
import HandWeel from './handwheel';
import Jenkins from './moveable/jenkins';

export const Objects = [Chair, SpaceSuit, Navigator,
    Shield, CargoScanner, Hammer, Table, Medbed, VacuumCleaner,
    Cryopod, O2Tank, Potato, Server, Han, FireExtinguisher];

const InitialObjects = Objects.concat([
   GunTerminal, HandWeel, Jenkins
]);

export function produceByType(room, type, count = 1) {
    let klass = Objects.find(o => o.type === type);
    if (!klass) throw new Error("unknown type:" + type + ", from objects: " + JSON.stringify(room.objectsProp));

    return produceMany(room, klass, count);
}

export function produceByRarity(room, rarity, count = 1) {
    let filtered = Objects.filter(o => o.rarity === rarity);
    let klass = game.rnd.pick(filtered);
    if (!klass) throw new Error("No objects with rarity:" + rarity);

    return produceMany(room, klass, count);
}

export function produceInitialAtLT(left, top, type) {
    let klass = InitialObjects.find(o => o.type === type);
    if (!klass) throw new Error("Unknown type: '" + type + "'");
    let item = new klass(left, top);
    //reallign
    item.x -= (item.left - left);
    item.y -= (item.top - top);
    return item;
}

export function produceMany(room, klass, count = 1) {
    let items = [];
    for (let i = 0; i < count; i++) {
        //todo[grishin]: create x/y in Room object
        let x = game.rnd.integerInRange(room.rect.x, room.rect.x + room.rect.width - klass.width * 2);
        let y = game.rnd.integerInRange(room.rect.y, room.rect.y + room.rect.height - klass.height * 2);
        let item = new klass(x, y);
        items.push(item);
    }
    return items;

}



// WEBPACK FOOTER //
// ./src/objects/items/items_factory.js